<div class="SLV2-main-wrapper">
    <div class="col-xl-2 col-md-3" *ngIf="selfLearnService.isFromLearn()">
        <app-sidebar-learn></app-sidebar-learn>    
    </div> 
    <div class="SLV2-body-section" *ngIf="!isLoading">
        <app-subject-topic-header 
            [bannerSubject]="subjectName"
            [isTopicsHeader]="true"
            [bannerData]="headerBannerdata"
        ></app-subject-topic-header>
        <div class="SLV2-body-col-wrap-section">

            <div class="SLV2-body-section">

                <div class="SLV2-section-wrap">
                <mat-tab-group [(selectedIndex)]="currentTabIndex" 
                class="SLV2-mat-tab {{subjectName?.replace(' ','') | lowercase}}"
                (selectedTabChange)="onTabChanged($event);" 
                animationDuration="500ms">
                    <mat-tab label="Learn">
                        <app-chapter-learn-tab 
                            [tabSubject]="subjectName" 
                            [tabTopicData]="topicdata"
                            [tabBannerData]="learnBannerData"
                            [expandRowIndex]="expandRowIndex"
                        ></app-chapter-learn-tab>
                    </mat-tab>
                    <mat-tab label="Practice">
                        <app-chapter-practice-tab
                            [tabSubject]="subjectName" [InteractiveStoriesList]="InteractiveStoriesList"> 
                        </app-chapter-practice-tab>
                    </mat-tab>
                    <mat-tab label="Revise">
                        <app-chapter-revise-tab
                            [tabSubject]="subjectName" [isMemoryCardsAvailable]="memoryCardQuestionsData.length >0 ? true : false"
                        >
                        </app-chapter-revise-tab>
                    </mat-tab>
                </mat-tab-group>
                </div>

            </div>
              <ng-container *ngIf="isMemoryCardsAvailable || InteractiveStoriesList.length >0">
            <app-ads-sidebar [isMemoryCardsAvailable] ="isMemoryCardsAvailable" [isInteracticeCardsAvailable]="isInteracticeCardsAvailable" (exploreInteractiveActivities)="changeTabIndex($event)"></app-ads-sidebar>
              </ng-container> 
        </div>
    </div>
</div>